import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, HashRouter, Switch, Redirect } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss";

import Index from "views/Index.jsx";
import Hero from "./views/IndexSections/PageBanner"
import Whoweare from "./views/IndexSections/Whoweare"
import GlobalLifestyleVentures from "views/pages/GlobalLifestyleVentures.jsx";
import CommoditySupplyChain from "views/pages/CommoditySupplyChain.jsx";
import FamilyOffice from "views/pages/FamilyOffice.jsx";
import PrivateCapital from "views/pages/PrivateCapital.jsx";
import Realestate from "views/pages/Realestate.jsx";
import ScrollToTop from "./views/IndexSections/ScroolToTop.jsx";
import EnergySolutions from "views/pages/EnergySolutions.jsx";
import EngineeringInfrastructure from "views/pages/EngineeringInfrastructure.jsx";
import AiTelecomNetworks from "views/pages/AiTelecomNetworks.jsx";
import Medical from "views/pages/Medical.jsx";
import DefenseSystems from "views/pages/DefenseSystems";
import CSR from "views/pages/CSR";
import ContactUsPage from "views/pages/ContactUsPage.jsx";

const mapConsumerHash = hash => {
  if (hash === "#luxury") return "#hospitality";
  return hash || "";
};

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <Switch>
        <Route
          path="/"
          exact 
          render={props => <Index {...props} />}
        />
        <Route
          path="/commodity-supply-chain"
          exact
          render={props => <CommoditySupplyChain {...props} />}
        />
        <Route
          path="/global-lifestyle-ventures"
          exact
          render={props => <GlobalLifestyleVentures {...props} />}
        />
        <Route
          path="/energy-solutions"
          exact
          render={props => <EnergySolutions {...props} />}
        />
         <Route
          path="/engineering-infrastructure"
          exact
          render={props => <EngineeringInfrastructure {...props} />}
        />
        <Route
          path="/ai-telecom-networks"
          exact
          render={props => <AiTelecomNetworks {...props} />}
        />

        <Route
          path="/medical"
          exact
          render={props => <Medical {...props} />}
        />
        <Route
          path="/defense-systems"
          exact
          render={props => <DefenseSystems {...props} />}
        />
        <Route
          path="/strategic-investments/family-office"
          exact
          render={props => <FamilyOffice {...props} />}
        />
        <Route
          path="/strategic-investments/private-capital"
          exact
          render={props => <PrivateCapital {...props} />}
        />
        <Route
          path="/strategic-investments"
          exact
          render={() => <Redirect to="/strategic-investments/private-capital" />}
        />
        <Route
          path="/global-consumer-markets"
          exact
          render={props => (
            <Redirect
              to={{
                pathname: "/global-lifestyle-ventures",
                search: props.location.search,
                hash: mapConsumerHash(props.location.hash),
              }}
            />
          )}
        />
        <Route path="/food" exact render={() => <Redirect to="/global-lifestyle-ventures#food" />} />
        <Route path="/luxury" exact render={() => <Redirect to="/global-lifestyle-ventures#hospitality" />} />
        <Route path="/engineering-technology" exact render={() => <Redirect to="/engineering-infrastructure" />} />
        <Route path="/entertainment-agency" exact render={() => <Redirect to="/global-lifestyle-ventures#entertainment" />} />
        <Route path="/defense" exact render={() => <Redirect to="/defense-systems" />} />
        <Route path="/investment" exact render={() => <Redirect to="/strategic-investments/private-capital" />} />
        <Route
          path="/csr"
          exact
          render={props => <CSR {...props} />}
        />
        <Route
          path="/contact-us"
          exact
          render={props => <ContactUsPage {...props} />}
        />
        <Redirect to="/#" />
      </Switch>
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById("root")
);
